import {Outlet} from 'react-router'

import {PlantMonitoringProvider} from './general/context/PlantMonitoringContext'
import {SignalMetadataProvider} from './general/context/SignalMetadataContext'
import {PmMain, PmInternalRoutes} from './general/pages/Main'
import {PlantProvider} from './kms/context/PlantContext'
import {KmsMain, KmsRoutes} from './kms/pages/Main'

export const PmWrapper = () => {
  return (
    <PlantProvider>
      <PlantMonitoringProvider>
        <SignalMetadataProvider>
          <Outlet />
        </SignalMetadataProvider>
      </PlantMonitoringProvider>
    </PlantProvider>
  )
}

export const PmRoutes = [
  {
    path: 'kms/*',
    element: <KmsMain />,
    children: [...KmsRoutes]
  },
  {
    path: '*',
    element: <PmMain />,
    children: [...PmInternalRoutes]
  }
]
